<template>
    <button type="button"
            ref="btn"
            class="jc-btn"
            :autofocus="false"
            :class="[
            type ? type : '',
            size ? size : '',
            radius && !rightAngle ? 'is-radius' : '',
            loading ? 'is-loading' : '',
            disabled ? 'is-disabled' : '',
            rightAngle ? 'is-right-angle': '',
            half ? 'is-half' : '',
            block ? 'is-block' : '']"
            @click.stop="onClickHandle">
      <template v-if="loading"><i class="jc-btn-loading jc-icon icon-loading"></i></template>
      <slot></slot>
    </button>
</template>

<script>
const COMPONENT_NAME = 'jc-btn'
export default {
  name: COMPONENT_NAME,
  props: {
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator (value) {
        if (!value) return true
        return /^(lg|md|sm)$/.test(value)
      }
    },
    disabled: Boolean,
    loading: Boolean,
    radius: {
      type: Boolean,
      default: true
    },
    block: Boolean,
    rightAngle: Boolean,
    half: Boolean
  },
  data () {
    return {
      clickTimer: null
    }
  },
  methods: {
    onClickHandle (e) {
      if (this.disabled) {
        this.$emit('disabled', e)
        return
      }
      if (this.loading) {
        this.$emit('loading', e)
        return
      }
      this.$emit('click', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/button/button.vue